import { render, staticRenderFns } from "./GlobalCommentInput.vue?vue&type=template&id=0a135d9c&scoped=true"
import script from "./GlobalCommentInput.vue?vue&type=script&lang=ts"
export * from "./GlobalCommentInput.vue?vue&type=script&lang=ts"
import style0 from "./GlobalCommentInput.vue?vue&type=style&index=0&id=0a135d9c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a135d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a135d9c')) {
      api.createRecord('0a135d9c', component.options)
    } else {
      api.reload('0a135d9c', component.options)
    }
    module.hot.accept("./GlobalCommentInput.vue?vue&type=template&id=0a135d9c&scoped=true", function () {
      api.rerender('0a135d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Comments/GlobalCommentInput.vue"
export default component.exports